var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist96(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3542 21.9478V23.9894H15.3125V21.9478H17.3542ZM15.3125 30.6248H17.3542V28.5832H15.3125V30.6248ZM15.3125 37.2603H17.3542V35.2186H15.3125V37.2603Z",
    fill: "#009FDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8854 22.4582H33.6875V23.479H18.8854V22.4582ZM18.8854 30.1144H33.6875V29.0936H18.8854V30.1144ZM18.8854 36.7498H33.6875V35.729H18.8854V36.7498ZM39.8125 16.1239V40.8332C39.8125 42.5245 38.4414 43.8957 36.75 43.8957H12.25C10.5586 43.8957 9.1875 42.5245 9.1875 40.8332V8.1665C9.1875 6.47513 10.5586 5.104 12.25 5.104H28.7926L39.8125 16.1239ZM29.0938 13.7811C29.0938 14.9087 30.0078 15.8228 31.1354 15.8228H38.072L29.0938 6.84452V13.7811ZM38.7917 40.8332V16.8436H31.1354C29.444 16.8436 28.0729 15.4725 28.0729 13.7811V6.12484H12.25C11.1224 6.12484 10.2083 7.03892 10.2083 8.1665V40.8332C10.2083 41.9608 11.1224 42.8748 12.25 42.8748H36.75C37.8776 42.8748 38.7917 41.9608 38.7917 40.8332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist96);
export default __webpack_public_path__ + "static/media/checklist_96.ebcd8fc14839735ee5905257cbefa7f3.svg";
export { ForwardRef as ReactComponent };